import { Injectable } from '@angular/core';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { Design } from 'src/app/models/domain';
import { YPMDESIGNSRVDesign } from 'src/generated-clients/design';

@Injectable({
  providedIn: 'root',
})
export class DesignAdapter implements IAdapter<Design, YPMDESIGNSRVDesign> {
  private readonly internalKey = 'M';

  public adaptToDomain(item: YPMDESIGNSRVDesign): Design {
    return new Design(
      fallbackString(item.designId),
      fallbackString(item.superDesign),
      fallbackString(item.authorizationGroup),
      fallbackString(item.launchDescription),
      fallbackDate(item.globalLaunchDate) ?? undefined,
      fallbackString(item.designDescription),
      Boolean(item.qa40c),
      Boolean(item.qa20c),
      fallbackString(item.designer),
      fallbackString(item.designerName),
      fallbackString(item.responsibleUser),
      fallbackString(item.responsibleName),
      this.makeBuyToInternalExternal(item.makeBuy),
      fallbackString(item.usability),
      fallbackString(item.usabilityText),
      // materialGroup isn't in the spec, but it's in the actual data
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      fallbackString((item as any).materialGroup)
    );
  }

  private makeBuyToInternalExternal(makeBuy: string | undefined): 'External' | 'Internal' {
    return makeBuy === this.internalKey ? 'Internal' : 'External';
  }
}
